import { render, staticRenderFns } from "./trends.vue?vue&type=template&id=255c7b78&"
import script from "./trends.vue?vue&type=script&lang=js&"
export * from "./trends.vue?vue&type=script&lang=js&"
import style0 from "./trends.vue?vue&type=style&index=0&id=255c7b78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports